import React from 'react';
import { Box, Typography } from '@mui/material';

export const HelpSupportHeader: React.FC = () => {
  return (
    <>
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          borderRadius: '10px',
          border: '1px solid #e6e6ea',
          backgroundColor: '#fff',
          px: 2,
          py: 1,
          color: '#717182',
          fontSize: 14,
        }}
      >
        <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#1d2b2d' }}>Help</Typography>
      </Box>

      <Box>
        <Typography sx={{ fontSize: 32, lineHeight: 1.2, fontWeight: 500, color: '#1d2b2d' }}>Help and Support</Typography>
        <Typography sx={{ mt: 1, fontSize: 16, color: '#717182' }}>
          Find product guides, explore FAQs, or get help when you need it.
        </Typography>
      </Box>
    </>
  );
};
